import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hide } from "providers/toastSlice";
import { HugeiconsIcon } from '@hugeicons/react';
import { CheckmarkCircle01Icon, Alert01Icon, Cancel01Icon } from '@hugeicons/core-free-icons';

const config = {
    success: {
        icon: CheckmarkCircle01Icon,
        iconColor: 'text-emerald-500',
        border: 'border-l-emerald-500',
        bg: 'bg-white dark:bg-gray-900',
        text: 'text-gray-800 dark:text-gray-100',
        sub: 'text-gray-500 dark:text-gray-400',
    },
    error: {
        icon: Alert01Icon,
        iconColor: 'text-red-500',
        border: 'border-l-red-500',
        bg: 'bg-white dark:bg-gray-900',
        text: 'text-gray-800 dark:text-gray-100',
        sub: 'text-gray-500 dark:text-gray-400',
    },
    token: {
        icon: Alert01Icon,
        iconColor: 'text-red-500',
        border: 'border-l-red-500',
        bg: 'bg-white dark:bg-gray-900',
        text: 'text-gray-800 dark:text-gray-100',
        sub: 'text-gray-500 dark:text-gray-400',
    },
};

function Toast() {
    const dispatch = useDispatch();
    const state = useSelector(s => s.toast.state);
    const message = useSelector(s => s.toast.message);
    const type = useSelector(s => s.toast.type);

    useEffect(() => {
        if (state && type !== 'token') {
            const id = setTimeout(() => dispatch(hide()), 4000);
            return () => clearTimeout(id);
        }
    }, [state, type, dispatch]);

    const cfg = config[type] || config.error;

    return (
        <div
            className={`fixed top-4 right-4 z-50 transition-all duration-300 ${
                state ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2 pointer-events-none'
            }`}
        >
            <div className={`flex items-start gap-3 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 border-l-4 ${cfg.border} ${cfg.bg} px-4 py-3.5 max-w-sm w-full`}>
                <HugeiconsIcon icon={cfg.icon} size={20} className={`shrink-0 mt-0.5 ${cfg.iconColor}`} />

                <div className="flex-1 min-w-0">
                    <p className={`text-sm font-medium leading-snug ${cfg.text}`}>
                        {type === 'token' ? 'Session expired' : type === 'success' ? 'Success' : 'Error'}
                    </p>
                    <p className={`text-xs mt-0.5 leading-snug ${cfg.sub}`}>{message}</p>
                </div>

                <button
                    onClick={() => dispatch(hide())}
                    className="shrink-0 p-0.5 rounded text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
                    aria-label="Dismiss"
                >
                    <HugeiconsIcon icon={Cancel01Icon} size={14} />
                </button>
            </div>
        </div>
    );
}

export default Toast;
